import React, { useState } from 'react';
import './style.scss';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import IconButton from '../IconButton/index.js';
import AddNewCustomerForm from '../AddNewCustomerFofm/AddNewCustomerFofm.jsx';
import { CUSTOMER_SERVICE_MODEL } from '../../../utils/enums.js';

const TableAddButton = ({ label, onClick }) => (
    <button type={'button'} className={'tableAddButton'} onClick={onClick}>
        <IconButton isIcon iconName={'iconPlus'} />
        <span>{label}</span>
    </button>
);

export const AddOrderButton = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const onAdd = () => {
        history.push("/new-order", { prevUrl: window.location.pathname });
    }

    return <TableAddButton label={t('orders.ADD_ORDER_LABEL')} onClick={onAdd} />;
}

export const AddCallCenterOrderButton = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const enableCallCenterMode = useSelector(state => state?.restaurant?.data?.configuration?.enableCallCenterMode);

    if (!enableCallCenterMode) return null;

    return <TableAddButton label={t('orders.ADD_ORDER_LABEL')} onClick={() => history.push('/create-order')} />;
}

export const AddCustomerButton = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [isAddOpen, setIsAddOpen] = useState(false);

    const onCreateUser = (user) => {
        setIsAddOpen(false);
        history.push(CUSTOMER_SERVICE_MODEL.customers + '?userId=' + user.id);
    }

    return (
        <>
            <TableAddButton label={t('customers.ADD_CUSTOMER')} onClick={() => setIsAddOpen(true)} />

            <div className={classNames('tableAddButtonLayout', { open: isAddOpen })}>
                <IconButton isIcon={true} iconName={"cancel"} onClick={() => setIsAddOpen(false)} />
                <AddNewCustomerForm onCreateUser={onCreateUser} />
            </div>
        </>
    );
}

export default TableAddButton;
